import __ from "../admin-utils/LanguageHelper"

export default {
  table: {
    filterButtonText: __('بحث', 'Search') // Apply Filter
  }
}
